<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <interes-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import InteresProvider from "../../../../providers/InteresProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import InteresForm from "../InteresForm";
    
    


    export default {
        name: "InteresCreate",
         
        components: { InteresForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.interes.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    fechaDesde: null,
                    fechaHasta: null,
                    importeDesde: null,
                    importeHasta: null,
                    tasa: null
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    InteresProvider.createInteres(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createInteres)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

